console.log('client.js child loaded');